(() => {
  if (customElements.get('volume-offers')) return;
  customElements.define('volume-offers', class extends HTMLElement {
    connectedCallback() {
      this.onClick ||= this.copyCode.bind(this);
      this.addEventListener('click', this.onClick);
      this.querySelectorAll('[data-copy-code]').forEach(button => { button.hidden = false; });
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
    }

    async copyCode(event) {
      const button = event.target.closest('[data-copy-code]');
      if (!button || !this.contains(button) || button.disabled) return;
      const input = button.parentElement.querySelector('input');
      const status = this.querySelector('[role="status"]');
      if (!input || !status) return;
      button.disabled = true;
      status.textContent = '';
      try {
        await navigator.clipboard.writeText(input.value);
        status.textContent = this.dataset.copied;
      } catch (_) {
        // Clipboard may be unavailable or denied. Select the visible code for
        // manual copying; never report success when nothing was copied.
        input.focus();
        input.select();
        status.textContent = this.dataset.fallback;
      } finally {
        button.disabled = false;
      }
    }
  });
})();
